import { gettext } from '@eventbrite/i18n';
import { isStatsigInitialized } from '@eventbrite/statsig';
import { RatingDisplay } from '@eventbrite/trust-signals-lib';
import React from 'react';
import { isDisplayRatingFeatureGateEnabled } from '../../../statsig';
import { Organizer } from '../../../types';
import { useIsServerSideRendered } from '../../hooks/useIsServerSideRendered';
import './OrganizerInfo.scss';

export type Props = {
    profileLink: string;
    nameTruncated: string;
    organizerId: Organizer['id'];
    gaCategory?: string;
};

export const OrganizerInfo = ({
    profileLink,
    nameTruncated,
    organizerId,
    gaCategory,
}: Props) => {
    const isServerSideRendered = useIsServerSideRendered();

    const linkTitle = gettext("Go to the organizer's profile");

    const organizerNameMarkup = {
        __html: gettext(
            'By <a title="%(linkTitle)s" href="%(profileLink)s" target="_blank" rel="noreferrer">%(nameTruncated)s</a>',
            { profileLink, nameTruncated, linkTitle },
        ).toString(),
    };

    const hideUntilStatsigIsInitializedClass =
        isServerSideRendered ||
        (!isServerSideRendered && !isStatsigInitialized())
            ? 'eds-is-hidden-accessible'
            : '';

    return (
        <div className={`organizer-info ${hideUntilStatsigIsInitializedClass}`}>
            <div className="organizer-info__group">
                <div
                    className="organizer-info__name"
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={organizerNameMarkup}
                />
                {isDisplayRatingFeatureGateEnabled() && (
                    <RatingDisplay
                        organizerData={{
                            organizerId,
                            organizerName: nameTruncated,
                        }}
                        size="small"
                        filterRating
                        addClassToContainer={{
                            className: 'rating-organizer-info__container',
                        }}
                        trackCategory={gaCategory}
                    />
                )}
                <div className="organizer-info__follow">
                    <span id="listings-root__follow-organizer_hero"></span>
                </div>
            </div>
        </div>
    );
};
